<template>
    <div :style="cssProps">
        <div :style="{ 'margin-top': show && isMobile ? '56px' : '0px' }" :class="['page-flexbox-wrapper', 
        currentUrl ? 'bg-network-supplier' : '' ]">
            <TooltipStyle />
            <header-component :header-type="headerType" @show="show = $event"></header-component>
            <SupplierSideBar @show="show = $event" v-if="headerType == 'supplier' && !isMobile" />
            <main
                :class="[{ 'mobile-bottom': headerType == 'supplier' && isMobile }, containerLayout]"
                class="container"
            >
                <router-view :isMobile="isMobile" />
            </main>
            <vue-snotify></vue-snotify>
            <eg-cookies />
            <SupplierBottomBar :show="show" v-if="headerType == 'supplier' && isMobile" />
            <Footer v-if="headerType != 'supplier' && !userPartner && !hiddenFooter" />
            <RatingUser @close="ratingFeedbackClose" :show="ratingUserModal" :isMobile="isMobile" />
        </div>
    </div>
</template>

<script>
// Componentes
import SupplierSideBar from '@/layouts/header/supplier/desktop/side-bar';
import SupplierBottomBar from '@/layouts/header/supplier/mobile/bottom-bar';
import Header from '@/layouts/header/';
import Footer from '@/layouts/footer/';
import RatingUser from '@/components/modal/user-rating';
import TooltipStyle from '@/components/custom/tooltip';
import { mapState, mapActions } from 'vuex';
export default {
    name: 'Default',
    components: {
        'header-component': Header,
        Footer,
        RatingUser,
        TooltipStyle,
        SupplierSideBar,
        SupplierBottomBar
    },
    data: () => ({
        isMobile: false,
        show: false,
        showCookies: true,
        currentUrl: false
    }),
    methods: {
        ...mapActions('notification', ['setSnackbar']),
        ...mapActions('sweetalert2', ['setAlert']),
        ...mapActions('user', ['ratingFeedbackClose']),
        getUrl() {
            if(window.location.pathname === '/rede-de-perfis') {
                this.currentUrl = true;
            } else {
                this.currentUrl = false;
            }
        }
    },
    mounted() {
        this.setSnackbar(this.$snotify);
        this.setAlert(this.$swal);
        this.getUrl();
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    updated() {
        this.getUrl();
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('user', ['ratingUserModal']),
        ...mapState('signup', ['signup']),
        ...mapState('layout', ['sideMenu']),
        userPartner() {
            if (this.user.partner) {
                return this.user.partner.name.length;
            } else {
                return false;
            }
        },
        cssProps() {
            if (this.headerType == 'supplier' && !this.isMobile) {
                return {
                    '--left-page': this.show ? '100px' : '50px'
                };
            } else {
                return { '--left-page': '0px' };
            }
        },
        headerType() {
            const type = this.user.type;
            if (this.$route.meta.isSupplier) {
                if (type) return type.isSupplier ? 'supplier' : 'guest-supplier';
                else return 'guest-supplier';
            }
            if (this.$route.meta.isContractor) {
                if (type) {
                    return type.isContractor ||
                        type.isCondo ||
                        type.isPhysicalPerson ||
                        type.isCondoAdministrator ||
                        type.isRequester
                        ? 'contractor'
                        : 'guest-contractor';
                } else {
                    return 'guest-supplier';
                }
            } else if (this.$route.meta.header) {
                return this.$route.meta.header;
            } else if (!type) {
                return 'guest-contractor';
            } else if (type.isCondoAdministrator || type.isRequester) {
                return 'contractor';
            } else if (
                (type.isContractor || type.isCondo || type.isPhysicalPerson) &&
                (this.signup.type === 'contractor' ||
                    this.signup.type === 'physical-person' ||
                    this.signup.type === 'condominum')
            ) {
                return 'contractor';
            } else if (this.signup.type === 'supplier' && type.isSupplier) {
                return 'supplier';
            } else {
                return 'blank';
            }
        },
        containerLayout() {
            if (this.sideMenu && this.headerType === 'supplier') {
                return 'container-supplier-open';
            } else if (!this.sideMenu && this.headerType === 'supplier') {
                return 'container-supplier-close';
            } else {
                return '';
            }
        },
        hiddenFooter() {
            return this.$route.meta.hiddenFooter;
        }
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}
main {
    position: relative;
    left: var(--left-page);
    box-sizing: border-box;
    transition: 0.5s;
}
.mobile-bottom {
    margin-bottom: 55px;
}
.flatpickr-monthDropdown-months {
    display: inline !important;
}
[type='checkbox'].filled-in:checked + label:after {
    border: 2px solid #3949ab;
    background-color: #3949ab;
}
/* Debug do select por causa do materalize */
span.vs__selected {
    margin-bottom: -50px !important;
}
.row .input-field input:focus,
input.unit-price:focus,
.input-field textarea:focus,
.input-field input:focus {
    border-bottom: 1px var(--colorInput) solid !important;
    box-shadow: 0 0 0 0 !important;
}

/* Controle do container de fornecedor apenas acima do mobile*/
@media screen and (min-width: 769px) {
    .container.container-supplier-open {
        padding-left: 120px !important;
        padding-right: 105px;
        width: 95% !important;
        transition: 0.3s !important;
    }
    .container.container-supplier-close {
        padding-left: 10px !important;
        padding-right: 61px !important;
        width: 95% !important;
        transition: 0.3s !important;
    }
}

.eg-button-sweetalert {
    font-size: 16px;
    font-weight: 600;
    padding: 8px 15px;
    border: none;
    border-radius: 3px;
    box-shadow: none !important;
    position: relative;
    cursor: pointer;
    margin-right: 0.25rem /* 4px */;
}

.eg-button-sweetalert.eg-button-blue {
    color: #fff;
    background-color: #007bff !important;
    text-transform: capitalize;
}

.eg-button-sweetalert.eg-blue-outline {
    color: #007bff;
    background-color: #fff;
    box-shadow: inset 0px 0px 1px 1px #007bff !important;
    text-transform: capitalize;
}
.eg-button-sweetalert.eg-loading-btn {
    background-color: transparent !important;
    margin-right: 0;
    font-size: 30px;
}
.eg-button-sweetalert.eg-loading-btn::after {
    width: 30px !important;
    height: 30px !important;
}

/* Fazer o modal do sweetalert ter mais importancia do que o modal da aplicação */
.swal2-container {
    z-index: 1000000000000 !important;
}
/* AJUESTE DO TOAST FLEX */
.swal2-popup {
    display: flex !important;
}
/* ALINHANDO TEXTO DE SUBTITULO */
.swal2-html-container {
    text-align: center;
}
.bg-network-supplier {
    background-color: #f9f9f9;
}
</style>
<style lang="sass">
.page-flexbox-wrapper
    display: flex
    min-height: 100vh
    flex-direction: column

main
    flex: 1 1 auto
</style>
